import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-plan-details',
  imports: [],
  templateUrl: './plan-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './plan-details.component.scss',
})
export class PlanDetailsComponent {}
